import React, { Component } from "react"
import { connect } from "react-redux"
import PropTypes from "prop-types"
import { Dialog, Icon } from "react-weui"
import { X } from "react-feather"
import { values, sortBy } from "lodash"
import { push } from "connected-react-router"

import List from "./ListTemplate"
import { cities } from "../../../../data"
import { getSelections } from "../selectors"

import './ModalCitySelector.less'
import CitySelector from "./CitySelector";

class ModalCitySelector extends Component {
  constructor(props) {
    super(props)
    this.state = {
    }
  }

  getListData() {
    return sortBy(values(cities), "zsxOrder").filter(city => city.id != this.props.city).map(city => ({
      ...city,
      onClick:() => {
        this.props.onCity(city.id)
      }
    }))
  }

  allCitiesObject() {
    return {
      title: "所有城市",
      selected: !this.props.city,
      background: "/static/img/europe.png",
      footer: !this.props.city && <Icon value="success-no-circle" />,
      onClick: () => { this.props.onCity("") }
    }
  }

  selectedCity() {
    return values(cities).filter(city => city.id == this.props.city).map(city => ({
      ...city,
      selected: true,
      footer: <Icon value="success-no-circle" />,
      onClick:() => {
        this.props.onCity(city.id)
      }
    }))
  }

  render() {
    return (
      <Dialog
        type="ios"
        show
        className="mcs-dialog"
        style={{
          maxWidth: window.matchMedia("(min-width: 735px)").matches ? "360px" : "85%",
          width: window.matchMedia("(min-width: 735px)").matches ? "360px" : "85%",
        }}
      >
        <div className="dialog-heading">
          <div style={{flexGrow: 1}}>改变城市</div>
          <X
            size="52px"
            onClick={() => this.props.onClose(false)}
          />
        </div>
        
        <div className="scrolly">
          <CitySelector />
        </div>
      </Dialog>
    )
  }
}

ModalCitySelector.propTypes = {
  city: PropTypes.object.isRequired,
  onCity: PropTypes.func.isRequired, // cityId => void
  onClose: PropTypes.func.isRequired, // () => void
  includeEurope: PropTypes.bool,

  // from connect
  selections: PropTypes.object.isRequired,
  userInfo: PropTypes.object.isRequired,
  push: PropTypes.func.isRequired,
}

ModalCitySelector.defaultProps = {
  includeEurope: true
}

const mapStateToProps = (state, ownProps) => ({
  selections: getSelections(state, ownProps),
  userInfo: state.userInfo
})

const mapDispatchToProps = dispatch => ({
  push: (url) => dispatch(push(url)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ModalCitySelector)



// WEBPACK FOOTER //
// ./src/app/catalogo/components/ModalCitySelector.jsx